module.exports = __webpack_public_path__ + "static/media/icon-handsSmall.8def3256.svg";